import { render, staticRenderFns } from "./ServiceTypeFilter.vue?vue&type=template&id=52765627&"
import script from "./ServiceTypeFilter.vue?vue&type=script&lang=js&"
export * from "./ServiceTypeFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports